var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',_vm._b({staticStyle:{"z-index":"7"},attrs:{"id":"org-select","app":"","mini-variant-width":"74","width":"260","expand-on-hover":"","color":"accent"}},'v-navigation-drawer',_vm.$attrs,false),[_c('org-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }